//
//
//
//
//
//
//
//
//

export default {
  name: 'Card',
  props: { shadow: Boolean, title: String, titleIcon: String },
};
